import React from "react";
import { NavLink } from "react-router-dom";

export default function UpcomingNav() {
  return (
    <div className="eventNewsArea">
      <div className="container">
        <div className="row">
          <div className="eventNewsNav">
            <ul className="nav">
              <li>
                <NavLink
                  id="headNewsesBtn"
                  className="headNewsesBtn"
                  to="/news"
                >
                  News
                </NavLink>
              </li>
              <li>
                <NavLink
                  id="headEventsBtn"
                  className="headEventsBtn"
                  to="/event"
                >
                  Events
                </NavLink>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
